<template>
  <div class="church__container">
    <svg
      width="840"
      height="789"
      viewBox="0 0 840 789"
      fill="none"
      class="church"
    >
      <rect
        width="840"
        height="780"
        fill="#D8D8D8"
      />
      <mask
        id="mask0_0_330"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="840"
        height="789"
      >
        <rect
          width="840"
          height="789"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_0_330)">
        <rect
          y="-51"
          width="840"
          height="871"
          fill="url(#pattern0)"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_1')"
      >
        <circle
          cx="362.5"
          cy="194.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M364.046 189.992V200H362.781V191.571L360.231 192.501V191.359L363.848 189.992H364.046Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_2')"
      >
        <circle
          cx="458.5"
          cy="191.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M462.411 195.961V197H455.896V196.091L459.157 192.461C459.558 192.014 459.868 191.636 460.087 191.326C460.31 191.012 460.465 190.731 460.552 190.485C460.643 190.235 460.688 189.979 460.688 189.72C460.688 189.392 460.62 189.095 460.483 188.831C460.351 188.562 460.155 188.348 459.896 188.188C459.636 188.029 459.321 187.949 458.952 187.949C458.51 187.949 458.141 188.036 457.845 188.209C457.553 188.378 457.334 188.615 457.188 188.92C457.043 189.225 456.97 189.576 456.97 189.973H455.705C455.705 189.412 455.828 188.899 456.074 188.435C456.32 187.97 456.685 187.601 457.168 187.327C457.651 187.049 458.246 186.91 458.952 186.91C459.581 186.91 460.119 187.022 460.565 187.245C461.012 187.464 461.354 187.774 461.591 188.175C461.832 188.571 461.953 189.036 461.953 189.569C461.953 189.861 461.903 190.157 461.803 190.458C461.707 190.754 461.573 191.05 461.399 191.347C461.231 191.643 461.033 191.935 460.805 192.222C460.581 192.509 460.342 192.791 460.087 193.069L457.421 195.961H462.411Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_3')"
      >
        <circle
          cx="413.5"
          cy="249.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M412.735 249.401H413.638C414.08 249.401 414.444 249.328 414.731 249.183C415.023 249.032 415.24 248.829 415.381 248.574C415.527 248.314 415.6 248.023 415.6 247.699C415.6 247.316 415.536 246.995 415.408 246.735C415.281 246.476 415.089 246.28 414.834 246.147C414.579 246.015 414.255 245.949 413.863 245.949C413.508 245.949 413.193 246.02 412.92 246.161C412.651 246.298 412.439 246.494 412.284 246.749C412.134 247.004 412.059 247.305 412.059 247.651H410.794C410.794 247.146 410.922 246.685 411.177 246.271C411.432 245.856 411.79 245.525 412.25 245.279C412.715 245.033 413.253 244.91 413.863 244.91C414.465 244.91 414.991 245.017 415.442 245.231C415.894 245.441 416.244 245.756 416.495 246.175C416.746 246.59 416.871 247.107 416.871 247.727C416.871 247.977 416.812 248.246 416.693 248.533C416.579 248.816 416.399 249.08 416.153 249.326C415.912 249.572 415.597 249.775 415.21 249.935C414.823 250.09 414.358 250.167 413.815 250.167H412.735V249.401ZM412.735 250.44V249.682H413.815C414.449 249.682 414.973 249.757 415.388 249.907C415.802 250.058 416.128 250.258 416.365 250.509C416.607 250.759 416.775 251.035 416.871 251.336C416.971 251.632 417.021 251.928 417.021 252.225C417.021 252.689 416.942 253.102 416.782 253.462C416.627 253.822 416.406 254.127 416.119 254.378C415.837 254.629 415.504 254.818 415.121 254.945C414.738 255.073 414.321 255.137 413.87 255.137C413.437 255.137 413.029 255.075 412.646 254.952C412.268 254.829 411.933 254.651 411.642 254.419C411.35 254.182 411.122 253.893 410.958 253.551C410.794 253.204 410.712 252.81 410.712 252.368H411.977C411.977 252.715 412.052 253.018 412.202 253.277C412.357 253.537 412.576 253.74 412.858 253.886C413.146 254.027 413.483 254.098 413.87 254.098C414.257 254.098 414.59 254.032 414.868 253.899C415.151 253.763 415.367 253.558 415.518 253.284C415.673 253.011 415.75 252.667 415.75 252.252C415.75 251.837 415.663 251.498 415.49 251.233C415.317 250.965 415.071 250.766 414.752 250.639C414.438 250.507 414.066 250.44 413.638 250.44H412.735Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_4')"
      >
        <circle
          cx="410.5"
          cy="174.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M414.616 176.65V177.689H407.425V176.944L411.882 170.047H412.914L411.807 172.043L408.86 176.65H414.616ZM413.229 170.047V180H411.964V170.047H413.229Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_5')"
      >
        <circle
          cx="341.5"
          cy="267.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M340.489 268.263L339.478 268.003L339.977 263.047H345.083V264.216H341.05L340.749 266.923C340.931 266.818 341.161 266.72 341.439 266.629C341.722 266.538 342.046 266.492 342.41 266.492C342.87 266.492 343.283 266.572 343.647 266.731C344.012 266.886 344.322 267.11 344.577 267.401C344.837 267.693 345.035 268.044 345.172 268.454C345.309 268.864 345.377 269.322 345.377 269.828C345.377 270.307 345.311 270.746 345.179 271.147C345.051 271.549 344.857 271.899 344.598 272.2C344.338 272.496 344.01 272.727 343.613 272.891C343.221 273.055 342.759 273.137 342.226 273.137C341.825 273.137 341.444 273.082 341.084 272.973C340.729 272.859 340.41 272.688 340.127 272.46C339.849 272.228 339.621 271.94 339.443 271.599C339.27 271.252 339.161 270.847 339.115 270.382H340.318C340.373 270.756 340.482 271.07 340.646 271.325C340.811 271.58 341.025 271.774 341.289 271.906C341.558 272.034 341.87 272.098 342.226 272.098C342.526 272.098 342.793 272.045 343.025 271.94C343.258 271.836 343.454 271.685 343.613 271.489C343.773 271.293 343.894 271.056 343.976 270.778C344.062 270.5 344.105 270.188 344.105 269.842C344.105 269.527 344.062 269.236 343.976 268.967C343.889 268.698 343.759 268.463 343.586 268.263C343.417 268.062 343.21 267.907 342.964 267.798C342.718 267.684 342.435 267.627 342.116 267.627C341.692 267.627 341.371 267.684 341.152 267.798C340.938 267.912 340.717 268.067 340.489 268.263Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_6')"
      >
        <circle
          cx="477.5"
          cy="267.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M479.743 263.033H479.853V264.106H479.743C479.073 264.106 478.513 264.216 478.062 264.435C477.61 264.649 477.253 264.938 476.988 265.303C476.724 265.663 476.533 266.068 476.414 266.52C476.3 266.971 476.243 267.429 476.243 267.894V269.356C476.243 269.799 476.296 270.19 476.4 270.532C476.505 270.869 476.649 271.154 476.831 271.387C477.013 271.619 477.218 271.795 477.446 271.913C477.679 272.032 477.92 272.091 478.171 272.091C478.463 272.091 478.722 272.036 478.95 271.927C479.178 271.813 479.369 271.656 479.524 271.455C479.684 271.25 479.805 271.008 479.887 270.73C479.969 270.452 480.01 270.147 480.01 269.814C480.01 269.518 479.973 269.233 479.9 268.96C479.827 268.682 479.716 268.436 479.565 268.222C479.415 268.003 479.226 267.832 478.998 267.709C478.775 267.581 478.508 267.518 478.198 267.518C477.847 267.518 477.519 267.604 477.214 267.777C476.913 267.946 476.665 268.169 476.469 268.447C476.277 268.721 476.168 269.019 476.141 269.343L475.471 269.336C475.535 268.826 475.653 268.39 475.826 268.03C476.004 267.666 476.223 267.369 476.482 267.142C476.747 266.909 477.041 266.741 477.364 266.636C477.692 266.526 478.039 266.472 478.403 266.472C478.9 266.472 479.328 266.565 479.688 266.752C480.049 266.939 480.345 267.189 480.577 267.504C480.81 267.814 480.98 268.165 481.09 268.557C481.204 268.944 481.261 269.343 481.261 269.753C481.261 270.222 481.195 270.662 481.062 271.072C480.93 271.482 480.732 271.842 480.468 272.152C480.208 272.462 479.887 272.704 479.504 272.877C479.121 273.05 478.677 273.137 478.171 273.137C477.633 273.137 477.164 273.027 476.763 272.809C476.362 272.585 476.029 272.289 475.765 271.92C475.5 271.551 475.302 271.141 475.17 270.689C475.038 270.238 474.972 269.78 474.972 269.315V268.721C474.972 268.019 475.042 267.331 475.184 266.656C475.325 265.982 475.569 265.371 475.915 264.824C476.266 264.277 476.751 263.842 477.371 263.519C477.991 263.195 478.782 263.033 479.743 263.033Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_7')"
      >
        <circle
          cx="423.5"
          cy="313.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M427.322 309.047V309.758L423.2 319H421.867L425.982 310.086H420.596V309.047H427.322Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_8')"
      >
        <circle
          cx="310.5"
          cy="404.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M314.165 407.307C314.165 407.913 314.024 408.428 313.741 408.852C313.463 409.271 313.085 409.59 312.606 409.809C312.132 410.027 311.597 410.137 311 410.137C310.403 410.137 309.865 410.027 309.387 409.809C308.908 409.59 308.53 409.271 308.252 408.852C307.974 408.428 307.835 407.913 307.835 407.307C307.835 406.91 307.91 406.548 308.061 406.22C308.215 405.887 308.432 405.598 308.71 405.352C308.993 405.105 309.325 404.916 309.708 404.784C310.095 404.647 310.521 404.579 310.986 404.579C311.597 404.579 312.142 404.698 312.62 404.935C313.099 405.167 313.475 405.488 313.748 405.898C314.026 406.309 314.165 406.778 314.165 407.307ZM312.894 407.279C312.894 406.91 312.814 406.584 312.654 406.302C312.495 406.015 312.271 405.791 311.984 405.632C311.697 405.472 311.365 405.393 310.986 405.393C310.599 405.393 310.264 405.472 309.981 405.632C309.703 405.791 309.487 406.015 309.332 406.302C309.177 406.584 309.1 406.91 309.1 407.279C309.1 407.662 309.175 407.99 309.325 408.264C309.48 408.533 309.699 408.74 309.981 408.886C310.269 409.027 310.608 409.098 311 409.098C311.392 409.098 311.729 409.027 312.012 408.886C312.294 408.74 312.511 408.533 312.661 408.264C312.816 407.99 312.894 407.662 312.894 407.279ZM313.933 402.638C313.933 403.121 313.805 403.556 313.55 403.943C313.295 404.331 312.946 404.636 312.504 404.859C312.062 405.083 311.561 405.194 311 405.194C310.43 405.194 309.922 405.083 309.476 404.859C309.034 404.636 308.687 404.331 308.437 403.943C308.186 403.556 308.061 403.121 308.061 402.638C308.061 402.059 308.186 401.567 308.437 401.161C308.692 400.756 309.04 400.446 309.482 400.231C309.924 400.017 310.428 399.91 310.993 399.91C311.563 399.91 312.069 400.017 312.511 400.231C312.953 400.446 313.299 400.756 313.55 401.161C313.805 401.567 313.933 402.059 313.933 402.638ZM312.668 402.658C312.668 402.326 312.597 402.032 312.456 401.776C312.315 401.521 312.119 401.321 311.868 401.175C311.618 401.024 311.326 400.949 310.993 400.949C310.66 400.949 310.369 401.02 310.118 401.161C309.872 401.298 309.678 401.494 309.537 401.749C309.4 402.004 309.332 402.307 309.332 402.658C309.332 403 309.4 403.299 309.537 403.554C309.678 403.809 309.874 404.007 310.125 404.148C310.376 404.29 310.667 404.36 311 404.36C311.333 404.36 311.622 404.29 311.868 404.148C312.119 404.007 312.315 403.809 312.456 403.554C312.597 403.299 312.668 403 312.668 402.658Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_9')"
      >
        <circle
          cx="508.5"
          cy="404.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M507.147 408.94H507.277C508.007 408.94 508.599 408.838 509.055 408.633C509.51 408.428 509.861 408.152 510.107 407.806C510.354 407.459 510.522 407.07 510.613 406.637C510.704 406.199 510.75 405.75 510.75 405.29V403.766C510.75 403.314 510.698 402.913 510.593 402.562C510.493 402.212 510.351 401.918 510.169 401.681C509.991 401.444 509.788 401.264 509.561 401.141C509.333 401.018 509.091 400.956 508.836 400.956C508.544 400.956 508.282 401.015 508.05 401.134C507.822 401.248 507.628 401.41 507.469 401.619C507.314 401.829 507.195 402.075 507.113 402.357C507.031 402.64 506.99 402.948 506.99 403.28C506.99 403.576 507.027 403.864 507.1 404.142C507.173 404.42 507.284 404.67 507.435 404.894C507.585 405.117 507.772 405.295 507.995 405.427C508.223 405.554 508.49 405.618 508.795 405.618C509.077 405.618 509.342 405.563 509.588 405.454C509.839 405.34 510.06 405.188 510.251 404.996C510.447 404.8 510.602 404.579 510.716 404.333C510.834 404.087 510.903 403.829 510.921 403.561H511.522C511.522 403.939 511.447 404.312 511.297 404.682C511.151 405.046 510.946 405.379 510.682 405.68C510.417 405.98 510.107 406.222 509.752 406.404C509.396 406.582 509.009 406.671 508.59 406.671C508.098 406.671 507.672 406.575 507.312 406.384C506.951 406.192 506.655 405.937 506.423 405.618C506.195 405.299 506.024 404.944 505.91 404.552C505.801 404.155 505.746 403.754 505.746 403.349C505.746 402.875 505.812 402.43 505.944 402.016C506.076 401.601 506.272 401.236 506.532 400.922C506.792 400.603 507.113 400.354 507.496 400.177C507.883 399.999 508.33 399.91 508.836 399.91C509.406 399.91 509.891 400.024 510.292 400.252C510.693 400.48 511.019 400.785 511.27 401.168C511.525 401.551 511.712 401.981 511.83 402.46C511.949 402.938 512.008 403.431 512.008 403.937V404.395C512.008 404.91 511.974 405.434 511.905 405.967C511.841 406.495 511.716 407.001 511.529 407.484C511.347 407.967 511.08 408.4 510.729 408.783C510.379 409.161 509.921 409.462 509.355 409.686C508.795 409.904 508.102 410.014 507.277 410.014H507.147V408.94Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_10')"
      >
        <circle
          cx="410.5"
          cy="388.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M408.108 383.992V394H406.844V385.571L404.294 386.501V385.359L407.91 383.992H408.108ZM418.075 388.23V389.748C418.075 390.564 418.002 391.252 417.856 391.812C417.711 392.373 417.501 392.824 417.228 393.166C416.954 393.508 416.624 393.756 416.236 393.911C415.854 394.062 415.421 394.137 414.938 394.137C414.555 394.137 414.201 394.089 413.878 393.993C413.554 393.897 413.263 393.745 413.003 393.535C412.748 393.321 412.529 393.043 412.347 392.701C412.164 392.359 412.025 391.945 411.93 391.457C411.834 390.969 411.786 390.4 411.786 389.748V388.23C411.786 387.415 411.859 386.731 412.005 386.18C412.155 385.628 412.367 385.186 412.641 384.854C412.914 384.516 413.242 384.275 413.625 384.129C414.012 383.983 414.445 383.91 414.924 383.91C415.311 383.91 415.667 383.958 415.99 384.054C416.318 384.145 416.61 384.293 416.865 384.498C417.12 384.699 417.337 384.967 417.515 385.305C417.697 385.637 417.836 386.045 417.932 386.528C418.027 387.011 418.075 387.579 418.075 388.23ZM416.804 389.953V388.019C416.804 387.572 416.776 387.18 416.722 386.843C416.672 386.501 416.596 386.209 416.496 385.968C416.396 385.726 416.268 385.53 416.113 385.38C415.963 385.229 415.787 385.12 415.587 385.052C415.391 384.979 415.17 384.942 414.924 384.942C414.623 384.942 414.356 384.999 414.124 385.113C413.892 385.223 413.696 385.398 413.536 385.64C413.381 385.881 413.263 386.198 413.181 386.59C413.099 386.982 413.058 387.458 413.058 388.019V389.953C413.058 390.4 413.083 390.794 413.133 391.136C413.188 391.478 413.267 391.774 413.372 392.024C413.477 392.271 413.604 392.473 413.755 392.633C413.905 392.792 414.078 392.911 414.274 392.988C414.475 393.061 414.696 393.098 414.938 393.098C415.247 393.098 415.519 393.038 415.751 392.92C415.983 392.801 416.177 392.617 416.332 392.366C416.492 392.111 416.61 391.785 416.688 391.389C416.765 390.988 416.804 390.509 416.804 389.953Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_11')"
      >
        <circle
          cx="432.5"
          cy="519.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M430.108 514.992V525H428.844V516.571L426.294 517.501V516.359L429.91 514.992H430.108ZM437.983 514.992V525H436.719V516.571L434.169 517.501V516.359L437.785 514.992H437.983Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_12')"
      >
        <circle
          cx="413.5"
          cy="599.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M411.108 594.992V605H409.844V596.571L407.294 597.501V596.359L410.91 594.992H411.108ZM421.349 603.961V605H414.834V604.091L418.095 600.461C418.496 600.014 418.806 599.636 419.024 599.326C419.248 599.012 419.403 598.731 419.489 598.485C419.58 598.235 419.626 597.979 419.626 597.72C419.626 597.392 419.558 597.095 419.421 596.831C419.289 596.562 419.093 596.348 418.833 596.188C418.573 596.029 418.259 595.949 417.89 595.949C417.448 595.949 417.078 596.036 416.782 596.209C416.491 596.378 416.272 596.615 416.126 596.92C415.98 597.225 415.907 597.576 415.907 597.973H414.643C414.643 597.412 414.766 596.899 415.012 596.435C415.258 595.97 415.622 595.601 416.105 595.327C416.589 595.049 417.183 594.91 417.89 594.91C418.519 594.91 419.056 595.022 419.503 595.245C419.95 595.464 420.291 595.774 420.528 596.175C420.77 596.571 420.891 597.036 420.891 597.569C420.891 597.861 420.84 598.157 420.74 598.458C420.645 598.754 420.51 599.05 420.337 599.347C420.168 599.643 419.97 599.935 419.742 600.222C419.519 600.509 419.28 600.791 419.024 601.069L416.358 603.961H421.349Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_13')"
      >
        <circle
          cx="410.5"
          cy="435.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M408.108 430.992V441H406.844V432.571L404.294 433.501V432.359L407.91 430.992H408.108ZM413.673 435.401H414.575C415.017 435.401 415.382 435.328 415.669 435.183C415.961 435.032 416.177 434.829 416.318 434.574C416.464 434.314 416.537 434.023 416.537 433.699C416.537 433.316 416.473 432.995 416.346 432.735C416.218 432.476 416.027 432.28 415.771 432.147C415.516 432.015 415.193 431.949 414.801 431.949C414.445 431.949 414.131 432.02 413.857 432.161C413.589 432.298 413.377 432.494 413.222 432.749C413.071 433.004 412.996 433.305 412.996 433.651H411.731C411.731 433.146 411.859 432.685 412.114 432.271C412.369 431.856 412.727 431.525 413.188 431.279C413.652 431.033 414.19 430.91 414.801 430.91C415.402 430.91 415.929 431.017 416.38 431.231C416.831 431.441 417.182 431.756 417.433 432.175C417.683 432.59 417.809 433.107 417.809 433.727C417.809 433.977 417.749 434.246 417.631 434.533C417.517 434.816 417.337 435.08 417.091 435.326C416.849 435.572 416.535 435.775 416.147 435.935C415.76 436.09 415.295 436.167 414.753 436.167H413.673V435.401ZM413.673 436.44V435.682H414.753C415.386 435.682 415.91 435.757 416.325 435.907C416.74 436.058 417.066 436.258 417.303 436.509C417.544 436.759 417.713 437.035 417.809 437.336C417.909 437.632 417.959 437.928 417.959 438.225C417.959 438.689 417.879 439.102 417.72 439.462C417.565 439.822 417.344 440.127 417.057 440.378C416.774 440.629 416.441 440.818 416.059 440.945C415.676 441.073 415.259 441.137 414.808 441.137C414.375 441.137 413.967 441.075 413.584 440.952C413.206 440.829 412.871 440.651 412.579 440.419C412.287 440.182 412.06 439.893 411.896 439.551C411.731 439.204 411.649 438.81 411.649 438.368H412.914C412.914 438.715 412.989 439.018 413.14 439.277C413.295 439.537 413.513 439.74 413.796 439.886C414.083 440.027 414.42 440.098 414.808 440.098C415.195 440.098 415.528 440.032 415.806 439.899C416.088 439.763 416.305 439.558 416.455 439.284C416.61 439.011 416.688 438.667 416.688 438.252C416.688 437.837 416.601 437.498 416.428 437.233C416.255 436.965 416.008 436.766 415.689 436.639C415.375 436.507 415.004 436.44 414.575 436.44H413.673Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_14')"
      >
        <circle
          cx="644.5"
          cy="395.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M642.108 390.992V401H640.844V392.571L638.294 393.501V392.359L641.91 390.992H642.108ZM652.554 397.65V398.689H645.362V397.944L649.819 391.047H650.852L649.744 393.043L646.798 397.65H652.554ZM651.166 391.047V401H649.901V391.047H651.166Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_15')"
      >
        <circle
          cx="724.5"
          cy="599.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M722.108 594.992V605H720.844V596.571L718.294 597.501V596.359L721.91 594.992H722.108ZM727.427 600.263L726.415 600.003L726.914 595.047H732.021V596.216H727.987L727.687 598.923C727.869 598.818 728.099 598.72 728.377 598.629C728.66 598.538 728.983 598.492 729.348 598.492C729.808 598.492 730.22 598.572 730.585 598.731C730.95 598.886 731.259 599.11 731.515 599.401C731.774 599.693 731.973 600.044 732.109 600.454C732.246 600.864 732.314 601.322 732.314 601.828C732.314 602.307 732.248 602.746 732.116 603.147C731.989 603.549 731.795 603.899 731.535 604.2C731.275 604.496 730.947 604.727 730.551 604.891C730.159 605.055 729.696 605.137 729.163 605.137C728.762 605.137 728.382 605.082 728.021 604.973C727.666 604.859 727.347 604.688 727.064 604.46C726.786 604.228 726.559 603.94 726.381 603.599C726.208 603.252 726.098 602.847 726.053 602.382H727.256C727.311 602.756 727.42 603.07 727.584 603.325C727.748 603.58 727.962 603.774 728.227 603.906C728.495 604.034 728.808 604.098 729.163 604.098C729.464 604.098 729.73 604.045 729.963 603.94C730.195 603.836 730.391 603.685 730.551 603.489C730.71 603.293 730.831 603.056 730.913 602.778C731 602.5 731.043 602.188 731.043 601.842C731.043 601.527 731 601.236 730.913 600.967C730.826 600.698 730.697 600.463 730.523 600.263C730.355 600.062 730.147 599.907 729.901 599.798C729.655 599.684 729.373 599.627 729.054 599.627C728.63 599.627 728.309 599.684 728.09 599.798C727.876 599.912 727.655 600.067 727.427 600.263Z"
          fill="white"
        />
      </g>

      <g
        class="marker"
        @click="showModal('dot_16')"
      >
        <circle
          cx="97.5"
          cy="593.5"
          r="13"
          fill="#AF8D55"
          stroke="white"
        />
        <path
          d="M95.1084 588.992V599H93.8438V590.571L91.2939 591.501V590.359L94.9102 588.992H95.1084ZM103.681 589.033H103.79V590.106H103.681C103.011 590.106 102.45 590.216 101.999 590.435C101.548 590.649 101.19 590.938 100.926 591.303C100.661 591.663 100.47 592.068 100.352 592.52C100.238 592.971 100.181 593.429 100.181 593.894V595.356C100.181 595.799 100.233 596.19 100.338 596.532C100.443 596.869 100.586 597.154 100.769 597.387C100.951 597.619 101.156 597.795 101.384 597.913C101.616 598.032 101.858 598.091 102.108 598.091C102.4 598.091 102.66 598.036 102.888 597.927C103.116 597.813 103.307 597.656 103.462 597.455C103.621 597.25 103.742 597.008 103.824 596.73C103.906 596.452 103.947 596.147 103.947 595.814C103.947 595.518 103.911 595.233 103.838 594.96C103.765 594.682 103.653 594.436 103.503 594.222C103.353 594.003 103.163 593.832 102.936 593.709C102.712 593.581 102.446 593.518 102.136 593.518C101.785 593.518 101.457 593.604 101.151 593.777C100.851 593.946 100.602 594.169 100.406 594.447C100.215 594.721 100.105 595.019 100.078 595.343L99.4082 595.336C99.472 594.826 99.5905 594.39 99.7637 594.03C99.9414 593.666 100.16 593.369 100.42 593.142C100.684 592.909 100.978 592.741 101.302 592.636C101.63 592.526 101.976 592.472 102.341 592.472C102.838 592.472 103.266 592.565 103.626 592.752C103.986 592.939 104.282 593.189 104.515 593.504C104.747 593.814 104.918 594.165 105.027 594.557C105.141 594.944 105.198 595.343 105.198 595.753C105.198 596.222 105.132 596.662 105 597.072C104.868 597.482 104.67 597.842 104.405 598.152C104.146 598.462 103.824 598.704 103.441 598.877C103.059 599.05 102.614 599.137 102.108 599.137C101.571 599.137 101.101 599.027 100.7 598.809C100.299 598.585 99.9665 598.289 99.7021 597.92C99.4378 597.551 99.2396 597.141 99.1074 596.689C98.9753 596.238 98.9092 595.78 98.9092 595.315V594.721C98.9092 594.019 98.9798 593.331 99.1211 592.656C99.2624 591.982 99.5062 591.371 99.8525 590.824C100.203 590.277 100.689 589.842 101.309 589.519C101.928 589.195 102.719 589.033 103.681 589.033Z"
          fill="white"
        />
      </g>

      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlink:href="#image0_0_330"
            transform="scale(0.000807103 0.00077821)"
          />
        </pattern>
        <image
          id="image0_0_330"
          width="1239"
          height="1285"
          xlink:href="https://koalect-images.s3.eu-west-3.amazonaws.com/clients/kikirpa/church.jpg"
        />
      </defs>
    </svg>

    <modal
      v-show="modal.show"
      @close="modal.show = false"
    >
      <template #body>
        <article class="event">
          <div
            class="event__cover"
            :style="{ backgroundImage: `url(${ $i18n.translate(selected_dot.image) }), url(${ getImagePath('placeholders/project-card-cover.jpg') })` }"
          />

          <div class="event__infos">
            <h3
              class="title__section"
              v-if="$i18n.translate(selected_dot.title)"
            >
              {{ $i18n.translate(selected_dot.title) }}
            </h3>

            <div
              class="editor editor__content event__text"
              v-html="$i18n.translate(selected_dot.text)"
              v-if="$i18n.translate(selected_dot.text)"
            />

            <div class="progress-bar">
              <div
                class="progress-bar__current"
                :style="{ width: `${ getProgressbarValue }%` }"
              >
                <div class="progress-bar__label">
                  <app-money :amount="collected" />
                </div>
              </div>

              <span class="progress-bar__goal">
                <app-money :amount="goal" />
              </span>
            </div>

            <app-link
              :link="selected_dot.cta"
              class="btn translate__x3"
              v-slot="{ text }"
              v-if="selected_dot.cta && selected_dot.cta.show"
            >
              {{ text }}

              <fa-icon
                class="btn__icon element element"
                :icon="['fas', 'chevron-right']"
              />
            </app-link>
          </div>
        </article>
      </template>
    </modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import Modal from '&/organisms/AppModal'
import AppMoney from '&/atoms/AppMoney'
import { getImagePath } from '@/utils/utils'

export default {
  name: 'CustomHomepageKikirpaChurch',
  components: {
    Modal,
    AppMoney,
    AppLink: defineAsyncComponent(() => import('&/atoms/AppLink'))
  },
  setup: () => ({ getImagePath }),
  data () {
    return {
      modal: {
        show: false
      },
      goal: 4000000,
      selected_dot: {}
    }
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    stats: {
      type: Object,
      required: true
    }
  },
  computed: {
    getProgressbarValue () {
      return parseInt((this.collected / this.goal) * 100)
    },
    collected () {
      return this.stats.amount_collected || 0
    }
  },
  methods: {
    showModal (key) {
      this.selected_dot = this.section[key]
      this.modal.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.modal__container) {
  width: 100%;
  border-radius: 0;

  @media (min-width: 520px) {
    width: 520px;
  }
}

:deep(.modal__btn--close) {
  background-color: $white;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;

  &:hover svg {
    transform: rotate(90deg);
  }

  & svg {
    color: $color--primary;
    font-size: rem(22px);
    transition: all .3s;
  }
}

.church {
  min-width: 860px;
  position: relative;

  &__container {
    overflow-x: auto;

    @media (min-width: 850px) {
      overflow-x: hidden;
    }
  }
}

.marker {
  cursor: pointer;

  @supports ( transform-box: fill-box ) {
    transform-box: fill-box;
    transform-origin: 50% 50%;
    transition: all .2s;

    @include mq(sm) {
      &:hover {
        transform: translate(0, 0) scale(1.3);
      }
    }
  }
}

.event {
  width: 100%;
  background-color: $white;

  &--loading {
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__cover {
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    @include aspect-ratio(517, 241);
  }

  &__infos {
    position: relative;
    padding: 24px 30px;
    color: $black;

    .title__section {
      font-size: rem(24px);
      color: $color--primary;
      margin-bottom: 18px;
      text-align: left;
      line-height: 1.2;
      font-family: $font-family--secondary;
    }
  }

  &__text {
    margin-bottom: 38px;
    font-size: rem(14px);
  }

  &__chevron {
    font-size: 12px;
    margin-left: 6px;
  }

  &__link {
    display: flex;
    align-items: center;
    font-weight: bold;
  }
}

.progress-bar {
  width: 100%;
  height: 8px;
  position: relative;
  background: #EFEFEF;
  font-size: rem(13px);
  margin-bottom: 38px;
  margin-top: 38px;

  &__current {
    position: relative;
    background: $color--primary;
    height: 100%;
    max-width: 100%;
    text-align: right;
  }

  &__label {
    display: block;
    position: relative;
    transform: translateY(-100%);
    color: $color--primary;
  }

  &__goal {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    color: #111;
  }
}

:deep(.btn) {
  display: flex;
  align-items: center;
  background: $color--primary;
  padding: 12px 18px;
  line-height: 1;
  font-size: rem(18px);
  color: $white;
  transition: all .3s;
  border-radius: 0;
  width: fit-content;

  &:hover {
    background-color: shade($color--primary, 5%);
  }

  .btn__icon {
    font-size: 12px;
    margin-left: 6px;
  }

  .btn__container {
    justify-content: center;
    margin-top: 48px;
  }
}
</style>